export default __webpack_public_path__ + "LED_lamping_led-twM.svg";